// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.username-input {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  gap: 8px;
}

.information {
  white-space: pre-wrap;
}
.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cs-message--incoming .cs-message__content {
  border-radius: 0 0.7em 0.7em 0.7em;
}

.cs-message-list .cs-typing-indicator {
  background: transparent;
}
.TypingIndicator {
  background-color: #141f31;
}

.chat-box {
  height: calc(100vh - 35px);
  width: 50vw;
  z-index: 0;
}

#dark .scrollbar-container {
  background-color: #242530;

  /* background-color: #141f31; */
  background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412));
}

#light .scrollbar-container {
  background-color: #dad8d8;
}

#dark .cs-message__content {
  background-color: #373e4e;
  color: white;
}

#light .cs-message__content {
  background-color: white;
  color: black;
}
.cs-message__content {
  border-radius: 0 0.7em 0.7em 0.7em;
}
.cs-message--outgoing .cs-message__content {
  border-radius: 0.7em 0 0.7em 0.7em;
}

#dark .cs-message--outgoing .cs-message__content {
  background-color: #743f84;
  color: white;
}

#light .cs-message--outgoing .cs-message__content {
  background-color: #78c4efcc;
  color: black;
}

#dark .cs-message-input__content-editor-wrapper {
  background-color: #3d4354;
}

#light .cs-message-input__content-editor-wrapper {
  background-color: white;
}

.cs-message-input__content-editor[data-placeholder]:empty:before {
  text-align: start;
}

#dark .cs-message-input__content-editor[data-placeholder]:empty:before {
  background-color: #3d4354;
  color: rgba(255, 255, 255, 0.418);
}

#light .cs-message-input__content-editor[data-placeholder]:empty:before {
  background-color: white;
  color: rgba(0, 0, 0, 0.418);
}
.cs-message-input__content-editor[data-placeholder] {
  text-align: start;
}

#dark .cs-message-input__content-editor[data-placeholder] {
  background-color: #3d4354;
  color: white;
}

#light .cs-message-input__content-editor[data-placeholder] {
  background-color: white;
  color: black;
}

.cs-chat-container .cs-message-input {
  padding-bottom: 10px;
}

#dark .cs-chat-container .cs-message-input {
  background: transparent;
}

#light .cs-chat-container .cs-message-input {
  background-color: #bbbbbb;
  padding-bottom: 0 !important;
  height: 100%;
  display: flex;
  align-items: center;
}

#dark .cs-message-input__tools:first-child .cs-button:last-child {
  color: #7a8194;
}

#light .cs-message-input__tools:first-child .cs-button:last-child {
  color: #d6d7da;
}

#dark .cs-message-input__tools:last-child .cs-button:last-child {
  color: #7a8194;
}

#light .cs-message-input__tools:last-child .cs-button:last-child {
  color: #d6d7da;
}

.cs-main-container {
  border: 0;
  border-radius: 0px;
  background: transparent;
}
.cs-chat-container {
  background: transparent;
}
.cs-chat-container .cs-message-input {
  border-top: 0;
}
.time {
  color: white;
  text-align: center;
}

.timecoach {
  margin: 0;
  font-size: 12px;
}

.timecomment {
  text-align: end;
  margin: 0;
  font-size: 12px;
}

.timeuser {
  text-align: end;
  margin: 0;
  font-size: 12px;
}

#dark .timecoach {
  color: rgb(149, 149, 149);
}

#dark .timeuser {
  color: rgb(149, 149, 149);
}

#light .timecoach {
  color: black;
}

#light .timeuser {
  color: black;
}

.left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 1px solid #dad8d8;
  padding: 20px;
  border-radius: 10px;
  width: 20%;
  overflow-y: scroll;
  max-height: 89vh;
}

.button {
  margin-top: 8px;
  color: #090909;
  padding: 0.7em 1.7em;
  border-radius: 0.5em;
  cursor: pointer;
  height: -moz-fit-content;
  height: fit-content;
  border: 1px solid #e8e8e8;
  transition: all 0.3s;
}

.button:active {
  color: #666;
  box-shadow: inset 4px 4px 12px #c5c5c5, inset -4px -4px 12px #ffffff;
}

.button:disabled {
  color: white;
  background-color: #494949;
}

/* Loading text styles */
.loading-text-container {
  padding: 10px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

#dark .loading-text-container {
  color: #999;
}

#light .loading-text-container {
  color: #666;
}

.loading-text-content {
  font-style: italic;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

.loading-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

#dark .loading-spinner {
  border-color: #999;
  border-top-color: transparent;
}

#light .loading-spinner {
  border-color: #666;
  border-top-color: transparent;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.button:disabled:active {
  color: white;
  box-shadow: none;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.menu-item > p {
  margin: 0;
  white-space: normal;
  overflow-wrap: break-word;
}

.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input
  > p {
  color: white;
}

.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  background-color: white;
}

.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  color: white !important;
}

.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  color: white !important;
}

.rhap_additional-controls {
  display: none;
}

.rhap_rewind-button {
  display: none;
}

.rhap_forward-button {
  display: none;
}

[data-testid="ar_cancel"] {
  display: none;
}

.button-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 1px solid #dad8d8;
  padding: 20px;
  border-radius: 10px;
  max-height: 100%;
  min-width: 210px;
}

.id-list {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.id-list > p {
  margin: 0;
}

.comment > .cs-message__content-wrapper > .cs-message__content {
  background-color: thistle !important;
}

.input {
  padding: 8px;
  margin-top: 8px;
}

.radio-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 8px;
  justify-content: space-between;
}

.radio-label {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.green-line {
  height: 1px;
  flex-grow: 1;
  background-color: green;
}

.new-session {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}

.new-session > p {
  margin: 0;
  padding: 0 8px 0 8px;
  color: green;
}

.record-comment {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.edit-comment {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.new-user-modal {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
}

.interactive-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.mute-icon {
  background-color: #868686;
  padding: 6.65px;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  margin-top: 31.2px;
  margin-left: 50px;
}

.use-bot-voice {
  display: flex;
  align-items: center;
}

.use-bot-voice-container {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  label {
    font-weight: bold;
  }
}

@media screen and (max-width: 880px) {
  .left {
    width: auto;
  }

  .container {
    flex-direction: column;
  }
  .item:nth-child(1) {
    order: 2; /* Change order of div1 to be second */
  }

  .item:nth-child(2) {
    order: 1; /* Change order of div2 to be first */
  }
  .chat-box {
    height: calc(100vh - 120px);
    width: 400px;
    align-self: center;
  }

  .members {
    width: auto;
  }
}

@media screen and (max-width: 450px) {
  .chat-box {
    width: 300px;
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Chatbox/Chatbox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;;EAEzB,+BAA+B;EAC/B,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,wBAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oEAAoE;AACtE;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,QAAQ,EAAE,sCAAsC;EAClD;;EAEA;IACE,QAAQ,EAAE,qCAAqC;EACjD;EACA;IACE,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n}\n\n.username-input {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-self: center;\n  gap: 8px;\n}\n\n.information {\n  white-space: pre-wrap;\n}\n.buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cs-message--incoming .cs-message__content {\n  border-radius: 0 0.7em 0.7em 0.7em;\n}\n\n.cs-message-list .cs-typing-indicator {\n  background: transparent;\n}\n.TypingIndicator {\n  background-color: #141f31;\n}\n\n.chat-box {\n  height: calc(100vh - 35px);\n  width: 50vw;\n  z-index: 0;\n}\n\n#dark .scrollbar-container {\n  background-color: #242530;\n\n  /* background-color: #141f31; */\n  background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412));\n}\n\n#light .scrollbar-container {\n  background-color: #dad8d8;\n}\n\n#dark .cs-message__content {\n  background-color: #373e4e;\n  color: white;\n}\n\n#light .cs-message__content {\n  background-color: white;\n  color: black;\n}\n.cs-message__content {\n  border-radius: 0 0.7em 0.7em 0.7em;\n}\n.cs-message--outgoing .cs-message__content {\n  border-radius: 0.7em 0 0.7em 0.7em;\n}\n\n#dark .cs-message--outgoing .cs-message__content {\n  background-color: #743f84;\n  color: white;\n}\n\n#light .cs-message--outgoing .cs-message__content {\n  background-color: #78c4efcc;\n  color: black;\n}\n\n#dark .cs-message-input__content-editor-wrapper {\n  background-color: #3d4354;\n}\n\n#light .cs-message-input__content-editor-wrapper {\n  background-color: white;\n}\n\n.cs-message-input__content-editor[data-placeholder]:empty:before {\n  text-align: start;\n}\n\n#dark .cs-message-input__content-editor[data-placeholder]:empty:before {\n  background-color: #3d4354;\n  color: rgba(255, 255, 255, 0.418);\n}\n\n#light .cs-message-input__content-editor[data-placeholder]:empty:before {\n  background-color: white;\n  color: rgba(0, 0, 0, 0.418);\n}\n.cs-message-input__content-editor[data-placeholder] {\n  text-align: start;\n}\n\n#dark .cs-message-input__content-editor[data-placeholder] {\n  background-color: #3d4354;\n  color: white;\n}\n\n#light .cs-message-input__content-editor[data-placeholder] {\n  background-color: white;\n  color: black;\n}\n\n.cs-chat-container .cs-message-input {\n  padding-bottom: 10px;\n}\n\n#dark .cs-chat-container .cs-message-input {\n  background: transparent;\n}\n\n#light .cs-chat-container .cs-message-input {\n  background-color: #bbbbbb;\n  padding-bottom: 0 !important;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n#dark .cs-message-input__tools:first-child .cs-button:last-child {\n  color: #7a8194;\n}\n\n#light .cs-message-input__tools:first-child .cs-button:last-child {\n  color: #d6d7da;\n}\n\n#dark .cs-message-input__tools:last-child .cs-button:last-child {\n  color: #7a8194;\n}\n\n#light .cs-message-input__tools:last-child .cs-button:last-child {\n  color: #d6d7da;\n}\n\n.cs-main-container {\n  border: 0;\n  border-radius: 0px;\n  background: transparent;\n}\n.cs-chat-container {\n  background: transparent;\n}\n.cs-chat-container .cs-message-input {\n  border-top: 0;\n}\n.time {\n  color: white;\n  text-align: center;\n}\n\n.timecoach {\n  margin: 0;\n  font-size: 12px;\n}\n\n.timecomment {\n  text-align: end;\n  margin: 0;\n  font-size: 12px;\n}\n\n.timeuser {\n  text-align: end;\n  margin: 0;\n  font-size: 12px;\n}\n\n#dark .timecoach {\n  color: rgb(149, 149, 149);\n}\n\n#dark .timeuser {\n  color: rgb(149, 149, 149);\n}\n\n#light .timecoach {\n  color: black;\n}\n\n#light .timeuser {\n  color: black;\n}\n\n.left {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  border: 1px solid #dad8d8;\n  padding: 20px;\n  border-radius: 10px;\n  width: 20%;\n  overflow-y: scroll;\n  max-height: 89vh;\n}\n\n.button {\n  margin-top: 8px;\n  color: #090909;\n  padding: 0.7em 1.7em;\n  border-radius: 0.5em;\n  cursor: pointer;\n  height: fit-content;\n  border: 1px solid #e8e8e8;\n  transition: all 0.3s;\n}\n\n.button:active {\n  color: #666;\n  box-shadow: inset 4px 4px 12px #c5c5c5, inset -4px -4px 12px #ffffff;\n}\n\n.button:disabled {\n  color: white;\n  background-color: #494949;\n}\n\n/* Loading text styles */\n.loading-text-container {\n  padding: 10px;\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n#dark .loading-text-container {\n  color: #999;\n}\n\n#light .loading-text-container {\n  color: #666;\n}\n\n.loading-text-content {\n  font-style: italic;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n#dark .loading-spinner {\n  border-color: #999;\n  border-top-color: transparent;\n}\n\n#light .loading-spinner {\n  border-color: #666;\n  border-top-color: transparent;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.button:disabled:active {\n  color: white;\n  box-shadow: none;\n}\n\n.menu-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.menu-item > p {\n  margin: 0;\n  white-space: normal;\n  overflow-wrap: break-word;\n}\n\n.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input\n  > p {\n  color: white;\n}\n\n.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  background-color: white;\n}\n\n.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\n  color: white !important;\n}\n\n.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n  color: white !important;\n}\n\n.rhap_additional-controls {\n  display: none;\n}\n\n.rhap_rewind-button {\n  display: none;\n}\n\n.rhap_forward-button {\n  display: none;\n}\n\n[data-testid=\"ar_cancel\"] {\n  display: none;\n}\n\n.button-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  border: 1px solid #dad8d8;\n  padding: 20px;\n  border-radius: 10px;\n  max-height: 100%;\n  min-width: 210px;\n}\n\n.id-list {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.id-list > p {\n  margin: 0;\n}\n\n.comment > .cs-message__content-wrapper > .cs-message__content {\n  background-color: thistle !important;\n}\n\n.input {\n  padding: 8px;\n  margin-top: 8px;\n}\n\n.radio-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n  justify-content: space-between;\n}\n\n.radio-label {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.green-line {\n  height: 1px;\n  flex-grow: 1;\n  background-color: green;\n}\n\n.new-session {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.new-session > p {\n  margin: 0;\n  padding: 0 8px 0 8px;\n  color: green;\n}\n\n.record-comment {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.edit-comment {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n}\n\n.new-user-modal {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 8px;\n}\n\n.interactive-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.mute-icon {\n  background-color: #868686;\n  padding: 6.65px;\n  color: white;\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  margin-top: 31.2px;\n  margin-left: 50px;\n}\n\n.use-bot-voice {\n  display: flex;\n  align-items: center;\n}\n\n.use-bot-voice-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  label {\n    font-weight: bold;\n  }\n}\n\n@media screen and (max-width: 880px) {\n  .left {\n    width: auto;\n  }\n\n  .container {\n    flex-direction: column;\n  }\n  .item:nth-child(1) {\n    order: 2; /* Change order of div1 to be second */\n  }\n\n  .item:nth-child(2) {\n    order: 1; /* Change order of div2 to be first */\n  }\n  .chat-box {\n    height: calc(100vh - 120px);\n    width: 400px;\n    align-self: center;\n  }\n\n  .members {\n    width: auto;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .chat-box {\n    width: 300px;\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
